const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function apiFetch(path, { method = "GET", body, token } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }
  if (!res.ok) {
    let msg = null;
    if (data && data.detail) {
      if (typeof data.detail === "string") msg = data.detail;
      else if (Array.isArray(data.detail)) msg = data.detail.map((e) => e.msg || e.detail || JSON.stringify(e)).join(", ");
    }
    if (!msg) {
      // Non-JSON body (e.g. plain-text 500 or an HTML 502/504 gateway page)
      msg = res.status >= 500
        ? `Chyba serveru (HTTP ${res.status}). Zkuste to prosím znovu za chvíli.`
        : `Došlo k chybě (HTTP ${res.status}).`;
    }
    throw new Error(msg);
  }
  return data;
}

// Fetch a binary (PDF) with auth and open it in a new tab.
export async function openPdf(path, token) {
  const res = await fetch(`${API}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(await _binaryError(res, "Soubor se nepodařilo načíst"));
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Extract a human error message from a failed binary response (JSON detail if present).
async function _binaryError(res, fallback) {
  try {
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      const d = await res.json();
      if (d && d.detail) return typeof d.detail === "string" ? d.detail : fallback;
    }
  } catch (e) { /* ignore */ }
  return fallback;
}

// Fetch a binary (PDF/file) with auth and trigger a download (save to disk).
export async function downloadFile(path, token, filename) {
  const res = await fetch(`${API}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(await _binaryError(res, "Soubor se nepodařilo stáhnout"));
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "soubor.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Upload a file (multipart) with auth. `fields` adds extra form fields.
export async function uploadFile(path, file, token, fields = {}) {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  });
  let data = null;
  try { data = await res.json(); } catch (e) { data = null; }
  if (!res.ok) throw new Error((data && data.detail) || "Nahrání se nezdařilo");
  return data;
}
